export type RecaptchaAction = 'auth' | 'lead' | 'trade_in' | 'booking' | 'enquiry' | 'newsletter';

export const getRecaptchaToken = (action: RecaptchaAction): Promise<string> =>
  new Promise((res) => {
    globalThis.window.grecaptcha.enterprise.ready(() => {
      globalThis.window.grecaptcha.enterprise
        .execute(process.env.NEXT_PUBLIC_RECAPTCHA_TOKEN, { action })
        .then((token: string) => res(token));
    });
  });
